import { render } from "./loaderUpdate.vue?vue&type=template&id=aae122ca&scoped=true"
const script = {}

import "./loaderUpdate.vue?vue&type=style&index=0&id=aae122ca&lang=scss&scoped=true"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae122ca"]])

export default __exports__